import { render } from "./ResetPasswordComponent.vue?vue&type=template&id=294de7db&scoped=true"
import script from "./ResetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordComponent.vue?vue&type=script&lang=js"

import "./ResetPasswordComponent.vue?vue&type=style&index=0&id=294de7db&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294de7db"]])

export default __exports__